var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"flat":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-img',{attrs:{"width":"75","src":_vm.image.src}}),_vm._v(" "+_vm._s(_vm.catName)+" ")],1),_c('v-col',{attrs:{"cols":"6"}},[_vm._v(" "+_vm._s(_vm.price)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }